export const AUTH_CHECK = {
  INITIATE: 'AUTH_CHECK_INITIATE',
  SUCCESS: 'AUTH_CHECK_SUCCESS',
  FAILED: 'AUTH_CHECK_FAILED',
  CLEAR: 'AUTH_CHECK_CLEAR',
};

export const REFRESH_AUTH = {
  INITIATE: 'REFRESH_AUTH_INITIATE',
  SUCCESS: 'REFRESH_AUTH_SUCCESS',
  FAILED: 'REFRESH_AUTH_FAILED',
};

export const SET_LOGGED_IN_USER = 'SET_LOGGED_IN_USER';

export const LOGOUT_USER = 'LOGOUT_USER';

export const authCheckInitiate = () => ({
  type: AUTH_CHECK.INITIATE,
});

export const authCheckSuccess = () => ({
  type: AUTH_CHECK.SUCCESS,
});

export const authCheckFailed = () => ({
  type: AUTH_CHECK.FAILED,
});

export const refreshAuthInitiate = () => ({
  type: REFRESH_AUTH.INITIATE,
});

export const refreshAuthSuccess = () => ({
  type: REFRESH_AUTH.SUCCESS,
});

export const refreshAuthFailed = () => ({
  type: REFRESH_AUTH.FAILED,
});

export const setCurrentUser = userData => ({
  type: SET_LOGGED_IN_USER,
  user: userData,
});

export const logoutUser = () => ({
  type: LOGOUT_USER,
});

export const signIn = async () => {
  return window.zoauth.ZomatoAuth.signIn();
};

export const signOut = async () => {
  return window.zoauth.ZomatoAuth.logout();
};
